module.exports = __webpack_public_path__ + "img/Like - Outline.2f8c4aee.svg";